import { render, staticRenderFns } from "./Toma_member.vue?vue&type=template&id=51db3c90&scoped=true"
import script from "./Toma_member.vue?vue&type=script&lang=js"
export * from "./Toma_member.vue?vue&type=script&lang=js"
import style0 from "./Toma_member.vue?vue&type=style&index=0&id=51db3c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51db3c90",
  null
  
)

export default component.exports